import { render, staticRenderFns } from "./EgdsList.vue?vue&type=template&id=f2098fa2"
import script from "./EgdsList.vue?vue&type=script&lang=js"
export * from "./EgdsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports